<template><!-- svgo-optimised -->
<svg class="icon icon__plus-new" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 5v7M0 8.5h7" stroke="#090909"/></svg></template>